<template>
  <div class="pull-right">
    <div @click="generate" class="btn btn-primary btn-sm">
      <i class="fa fa-download" title="Download Excel"></i>
    </div>
  </div>
</template>
<script>
import download from "downloadjs";
import XLSX from "xlsx";
import VueJwtDecode from "vue-jwt-decode";
import http from "@/lib/http";

export default {
  props: ["tableId", "fileName", "fromExtFile", "downloadParam"],
  data() {
    return { mime: "data:application/vnd.ms-excel;base64," };
  },
  created() {
    // console.log("tabelId", this.tableId, "Filename", this.fileName);
  },
  methods: {
    async generate() {
      if (this.fromExtFile) {
        //"download/stock-history?download=1&companyname=ABB&isin=INE358A01014&sectorname=Pharmaceuticals",
        //{ user: j.identity.id, file: this.fileName+"."+type, date: new Date() },
        http.get(
          "download/schemes-history?download=1" + this.downloadParam,
          {},
          (error, response) => {
            console.log("submitted", response);
            if (response.responseType === "success") {
              window.open(response.download_link);
            } else {
              this.$toastr.error(response.status + ': ' + response.message, "", {});
            }
          }
        );

      } else {

        console.log("tabelId", this.tableId, "Filename", this.fileName);
        var dl = false;
        var type = "xlsx";
        var elt = document.getElementById(this.tableId);
        console.log(elt);
        var fileName = this.fileName;
        console.log(fileName);
        if (fileName.length > 31)
          fileName = fileName.substr(0, 29);
        // var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
        // return dl
        //   ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        //   : XLSX.writeFile(wb, this.fileName+'.' + (type || "xlsx"));
        const workBook = XLSX.utils.book_new(); // create a new blank book
        const workSheet = XLSX.utils.table_to_book(elt, { sheet: fileName });
        XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book
        // XLSX.writeFile(workSheet, this.fileName + "." + type); // initiate a file download in browser

        // console.log("tabelId", this.tableId, "Filename", this.fileName);
        // this.tableToExcel(this.tableId, this.fileName);
        // Update db
        var j = VueJwtDecode.decode(localStorage.getItem("token"));
        http.post(
          "updateDownload",
          { user: j.identity.id, file: this.fileName + "." + type, date: new Date() },
          (error, response) => {
            console.log("submitted", response);
            if (response.status === "success") {
              XLSX.writeFile(workSheet, fileName + "." + type); // initiate a file download in browser
            } else {
              this.$toastr.error(response.status + ': ' + response.message, "", {});
            }
          }
        );
      }
    },
    async tableToExcel() {
      {
        return this.export(this.jsonToXLS(), this.fileName + ".xls", this.mime);
      }
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    jsonToXLS(data) {
      this.mime =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      let xlsTemp =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml version="1.0" encoding="UTF-8" standalone="yes"?><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
      let xlsData = document.getElementById(this.tableId).innerHTML; //$("#"+this.tableId).html(); //
      // console.log("Json", xlsData, xlsTemp.replace("${table}", xlsData));
      return xlsTemp.replace("${table}", xlsData);
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Download.vue